import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Link from '@rad/components/utility/link';
import { stopEditorURL } from './_stop-editor';
// The pencil that opens a stop's contribution in its editor, there on every stop, published or not. A
// plain click goes through the wizard, which saves the tour first when it has changes to lose; one that
// opens a new tab leaves the wizard as it is.
const EditStopLink = (props) => {
    // Link prevents the default only for the clicks it handles itself.
    const onClick = (event) => {
        if (event.defaultPrevented)
            props.onEdit(props.home);
    };
    return _jsx(_Fragment, { children: _jsx(Link, { href: stopEditorURL(props.home), className: "btn btn-link text-body-secondary tour-icon-button", onClick: onClick, title: props.home.status === 'published' ? 'Edit this property' : 'Edit and publish this property', "aria-label": `Edit ${props.home.title}`, children: _jsx("i", { className: "bi bi-pencil", "aria-hidden": "true" }) }) });
};
export default EditStopLink;
